export const required = (value: any, lib: string) => {
    return (value ? '' : lib + ' est requis.');
}